import { XStack, YStack } from '@mythical/ui'
import { ContinueWatching } from 'app/blocks/homepage/continue-watching'
import ContentCard, {
  ContentCardProps,
} from 'app/components/content/ContentCard'
import { ContentCarousel } from 'app/components/content/ContentCarousel'
import { Button } from 'app/components/primitive/Button'
import {
  IconChevronLeft,
  IconChevronRight,
} from 'app/components/primitive/Icon'
import Section from 'app/components/structure/Section'
import { useCarouselController } from 'app/hooks/use-carousel-controller'
import React, { useCallback, useMemo } from 'react'

export const ContinueWatchingBlock: React.FC<{ block: ContinueWatching }> = ({
  block,
}) => {
  const { title, content } = block || {}
  const controller = useCarouselController()

  const processed = useMemo(
    () =>
      (content || []).map((item) => {
        return {
          ...item,
          secondsWatched: block?.timeMap?.find(
            (time) => time.contentId === item.id,
          )?.secondsWatched,
        }
      }),
    [content, block?.timeMap],
  )

  const renderItem = useCallback(
    (item: ContentCardProps) => <ContentCard {...item} />,
    [],
  )

  const keyExtractor = useCallback((item: ContentCardProps) => item.id, [])

  if (!content || content?.length === 0) {
    return null
  }

  return (
    <Section
      paddedX
      title={title || 'Continue Watching'}
      customCta={
        <XStack gap="$2" $sm={{ dsp: 'none' }}>
          <Button
            theme="white"
            onPress={controller.scrollToPrevious}
            disabled={!controller.canScrollPrevious}
            aria-label="Previous"
            icon={<IconChevronLeft size={16}  />}
            size="$3.5"
            circular
          />
          <Button
            theme="white"
            onPress={controller.scrollToNext}
            disabled={!controller.canScrollNext}
            aria-label="Next"
            circular
            size="$3.5"
            icon={<IconChevronRight size={16}  />}
          />
        </XStack>
      }
    >
      <YStack $gtSm={{ overflow: 'hidden' }}>
        <ContentCarousel
          items={processed}
          renderItem={renderItem}
          keyExtractor={keyExtractor}
          controllerRef={controller.carouselRef}
        />
      </YStack>
    </Section>
  )
}
